export const GET_CONTACTS_TRIP_CREATE_SCREEN = "GET_CONTACTS_TRIP_CREATE_SCREEN"
export const DRAGGED_WAYPOINTS = "DRAGGED_WAYPOINTS"
export const START_END_DELETED_REQUEST = "START_END_DELETED_REQUEST"
export const END_DELETED_REQUEST = "END_DELETED_REQUEST"

export const IS_TEMPLATE_TRUE = "IS_TEMPLATE_TRUE"
export const IS_TEMPLATE_MODAL_TRUE = "IS_TEMPLATE_MODAL_TRUE"
